/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_ListingsInputs */

const en_public_listings = /** @type {(inputs: Public_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public Listings`)
};

const es_public_listings = /** @type {(inputs: Public_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuncios públicos`)
};

const fr_public_listings = /** @type {(inputs: Public_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annonces publiques`)
};

const de_public_listings = /** @type {(inputs: Public_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffentliche Inserate`)
};

const ja_public_listings = /** @type {(inputs: Public_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開中の出品`)
};

const zh_public_listings = /** @type {(inputs: Public_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公开商品`)
};

const ar_public_listings = /** @type {(inputs: Public_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعلانات عامة`)
};

const id_public_listings = /** @type {(inputs: Public_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Publik`)
};

const it_public_listings = /** @type {(inputs: Public_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annunci Pubblici`)
};

const ru_public_listings = /** @type {(inputs: Public_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Публичные объявления`)
};

const pt_public_listings = /** @type {(inputs: Public_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anúncios Públicos`)
};

const ko_public_listings = /** @type {(inputs: Public_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공개된 상품`)
};

/**
* | output |
* | --- |
* | "Public Listings" |
*
* @param {Public_ListingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const public_listings = /** @type {((inputs?: Public_ListingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_ListingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_listings(inputs)
	if (locale === "es") return es_public_listings(inputs)
	if (locale === "fr") return fr_public_listings(inputs)
	if (locale === "de") return de_public_listings(inputs)
	if (locale === "ja") return ja_public_listings(inputs)
	if (locale === "zh") return zh_public_listings(inputs)
	if (locale === "ar") return ar_public_listings(inputs)
	if (locale === "id") return id_public_listings(inputs)
	if (locale === "it") return it_public_listings(inputs)
	if (locale === "ru") return ru_public_listings(inputs)
	if (locale === "pt") return pt_public_listings(inputs)
	return ko_public_listings(inputs)
});